import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { EnvironmentSpaceAccess } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id: string
  params?: EnvironmentSpaceAccess
  onSuccess?: () => void
  onError?: () => void
  children?: (response: EnvironmentSpaceAccess) => ReactElement
}

const UpdateEnvironmentSpaceAccessRequest = ({
  id,
  onSuccess,
  params,
  onError,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/agents/${id}/space_access`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='put'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default UpdateEnvironmentSpaceAccessRequest
